export default __webpack_public_path__ + "static/media/split-cells.4b72a834.svg";